import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './Proyectos.css';

const Proyectos = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalProject, setModalProject] = useState({});
  const [carouselKey, setCarouselKey] = useState(0);
  const [isModalReady, setIsModalReady] = useState(false);
  const haloRef = useRef(null);

  const carouselOptions = {
    type: 'slide',
    rewind: true,
    perPage: 1,
    pagination: true,
    arrows: true,
    autoplay: false,
    autoHeight: false,
    gap: '0rem',
    start: 0,
    focus: 'center',
    wheel: true,
    keyboard: true,
    classes: {
      arrows: 'splide__arrows',
      arrow: 'splide__arrow',
      prev: 'splide__arrow--prev',
      next: 'splide__arrow--next',
    },
    breakpoints: {
      768: {
        arrows: true,
        pagination: true
      },
      576: {
        arrows: false,
        pagination: true
      }
    }
  };

  useEffect(() => {
    // Efecto halo que sigue al mouse
    const handleMouseMove = (e) => {
      if (haloRef.current) {
        haloRef.current.style.left = `${e.clientX}px`;
        haloRef.current.style.top = `${e.clientY}px`;
      }
    };

    document.addEventListener('mousemove', handleMouseMove);

    // Cerrar modal con Escape
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isModalOpen) {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isModalOpen]);

  const projects = [
    { 
      id: 1, 
      title: 'Effluent Collector Ditch', 
      info: 'Instalación Geomembrana',
      image: '/images/fotos/windalco1/Windalco1_1.jpg',
      images: [
        '/images/fotos/windalco1/Windalco1_1.jpg',
        '/images/fotos/windalco1/Windalco1_2.jpg',
        '/images/fotos/windalco1/Windalco1_3.jpg',
        '/images/fotos/windalco1/Windalco1_11.jpg',
        '/images/fotos/windalco1/Windalco1_12.jpg',
        '/images/fotos/windalco1/Windalco1_13.jpg',
        '/images/fotos/windalco1/Windalco1_14.jpg',
        '/images/fotos/windalco1/Windalco1_15.jpg',
        '/images/fotos/windalco1/Windalco1_16.jpg',
      ],
      description: 'Instalación de 30,350 m² de Geomembrana de HDPE de 2mm doble cara texturizada WINDALCO / ECD (Effluent Collector Ditch)',
      date: '21 Marzo 2022 - 22 Abril 2022',
      location: 'Ewarthon, Jamaica',
      jamaica: true,
    },
    { 
      id: 2, 
      title: 'Effluent Holding Pond', 
      info: 'Instalación Geomembrana',
      image: '/images/fotos/windalco2/windalco2_2.jpg',
      images: [
        '/images/fotos/windalco2/windalco2_1.jpg',
        '/images/fotos/windalco2/windalco2_2.jpg',
        '/images/fotos/windalco2/windalco2_3.jpg',
        '/images/fotos/windalco2/windalco2_4.jpg',
      ],
      description: 'Instalación de 74,100 m² de Geomembrana de HDPE de 2mm doble cara texturizada y Geotextil WINDALCO / EHP (Effluent Holding Pond)',
      date: '10 Agosto 2022 - 4 Octubre 2022',
      location: 'Ewarthon, Jamaica',
      jamaica: true,
    },
    { 
      id: 3, 
      title: 'Effluent Holding Pond', 
      info: 'Instalación Geomembrana',
      image: '/images/fotos/windalco3/windalco_7.jpeg',
      images: [
        '/images/fotos/windalco1/Windalco1_11.jpg',
        '/images/fotos/windalco1/Windalco1_7.jpg',
        '/images/fotos/windalco1/Windalco1_3.jpg',
        '/images/fotos/windalco1/Windalco1_4.jpg',
        '/images/fotos/windalco1/Windalco1_15.jpg',
        '/images/fotos/windalco1/Windalco1_16.jpg',
        '/images/fotos/windalco1/Windalco1_7.jpg',
      ],
      description: 'Instalación de 55,649 m² de Geomembrana de HDPE de 2mm doble cara texturizada y Geotextil WINDALCO / EHP (Effluent Holding Pond)',
      date: '6 Mayo 2023 - 6 Junio 2023',
      location: 'Ewarthon, Jamaica',
      jamaica: true,
    },
    { 
      id: 4, 
      title: 'Power House Restoration', 
      info: 'Instalación de Tuberias',
      image: '/images/fotos/otros/power_house_restoration.jpeg',
      images: [
        '/images/fotos/jamalcoPiping/jamalcoPiping_1.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_2.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_3.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_4.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_5.jpg',
        '/images/fotos/estructura/estructura_6.jpeg',
        '/images/fotos/estructura/estructura_7.jpeg',
        '/images/fotos/estructura/estructura_8.jpeg',
        '/images/fotos/estructura/estructura_9.jpeg',
        '/images/fotos/estructura/estructura_10.jpeg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_6.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_7.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_8.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_16.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_17.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_18.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_19.jpg',
        '/images/fotos/jamalcoPiping/jamalcoPiping_20.jpg',
      ],
      description: 'Trabajos de Obra Mecánica y Tuberías para restauración de Powerhouse dentro de Refinería Jamalco en Hayes, Clarendon, Jamaica.',
      date: '09 Nov 2022 - 19 Nov 2022',
      location: 'Clarendon, Jamaica',
      jamaica: true,
    },
    { 
      id: 5, 
      title: 'Above Ground Storage Tanks - Phase 01', 
      info: 'Instalación de Geomembrana',
      image: '/images/fotos/jamalcoLinner/jamalcoLinner_10.jpg',
      images: [
        '/images/fotos/jamalcoLinner/jamalcoLinner_1.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_2.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_3.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_4.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_5.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_6.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_7.jpg',
        '/images/fotos/jamalcoLinner/jamalcoLinner_8.jpg',
      ],
      description: 'Instalación de Geomembrana de HDPE de 2mm doble cara texturizada y Geotextil JAMALCO en diques de Tanques para aprobación de NEPA.',
      date: '22 Febrero 2024 - 4 Mayo 2024',
      location: 'Clarendon, Jamaica',
      jamaica: true,
    },
    { 
      id: 6, 
      title: '45MW Steam Turbine Installation  - Civil & Structural Workpackage', 
      info: 'Construccion de edificio estructural',
      image:'/images/fotos/estructura/estructura_1.jpeg',
      images: [
        '/images/fotos/estructura/estructura_2.jpeg',
        '/images/fotos/estructura/estructura_3.jpeg',
        '/images/fotos/estructura/estructura_4.jpeg',
        '/images/fotos/estructura/estructura_5.jpeg',
        '/images/fotos/estructura/estructura_6.jpeg',
        '/images/fotos/estructura/estructura_7.jpeg',
        '/images/fotos/estructura/estructura_8.jpeg',
        '/images/fotos/estructura/estructura_9.jpeg',
        '/images/fotos/estructura/estructura_10.jpeg',
        '/images/fotos/estructura/estructura_11.jpeg',
        '/images/fotos/estructura/estructura_12.jpeg',



      ],
      description: 'Construcción de Edificio para Turbina de 45MW, Instalación de Estructura de Racks de Tubería.',
      date: 'Enero 2025 - Febrero 2026',
      location: 'Clarendon, Jamaica',
      jamaica: true,
    },
    { 
      id: 7, 
      title: 'Servicio de Topografía', 
      info: 'Servicio de Topografía',
      image: '/images/fotos/topografia/topografia_3.jpeg',
      images: [
        '/images/fotos/jamalcoStean/jamalcoStean_50.jpg',
        '/images/fotos/jamalcoStean/jamalcoStean_54.jpg',
        '/images/fotos/jamalcoStean/jamalcoStean_37.jpg',
        '/images/fotos/jamalcoStean/jamalcoStean_44.jpg',
        '/images/fotos/jamalcoStean/jamalcoStean_32.jpg',
        '/images/fotos/jamalcoStean/jamalcoStean_61.jpg',
      ],
      description: 'Servicio de Topografía para el desarrollo de las Obras Civiles y Estructurales dentro del Proyecto 45MW Steam Turbine Generator.',
      date: 'Enero 2025 - Mayo 2025',
      location: 'Hayse, Clarendon, Jamaica',
      jamaica: true,
    },
        { 
      id: 8, 
      title: 'Condensate Cooling Pond', 
      info: 'Instalación de Geosintetico',
      image: '/images/fotos/windalco3/windalco_1.jpeg',
      images: [
        '/images/fotos/windalco3/windalco_2.jpeg',
        '/images/fotos/windalco3/windalco_3.jpeg',
        '/images/fotos/windalco3/windalco_4.jpeg',
        '/images/fotos/windalco3/windalco_5.jpeg',
        '/images/fotos/windalco3/windalco_6.jpeg',
        '/images/fotos/windalco3/windalco_7.jpeg',
        '/images/fotos/windalco3/windalco_8.jpeg',
        '/images/fotos/windalco3/windalco_9.jpeg',
        '/images/fotos/windalco3/windalco_10.jpeg',
        '/images/fotos/windalco3/windalco_11.jpeg',
      ],
      description: 'Instalación de 16,150 m2',
      date: 'Abril 2025 - Octubre 2025',
      location: 'Jamalco',
      jamaica: true,
    },
            { 
      id: 9, 
      title: 'Above Ground Storage Containment', 
      info: 'Instalación de Geosinteticos',
      image: '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_29.jpeg',
      images: [
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_1.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_2.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_3.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_4.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_5.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_6.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_7.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_8.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_9.jpeg',
        '/images/fotos/aboveGroundStorageContainment/aboveGroundStorageContainment_10.jpeg',


      ],
      description: 'Instalación de Geosinteticos',
      date: 'Noviembre 2025 - Marzo 2026',
      location: 'Clarendon, Jamaica',
      jamaica: true,
    },
            { 
      id: 10, 
      title: '45MW Steam Turbine Installation - Piping Workpackage', 
      info: 'Instalacion de tuberias de sistema de vapor y sistemas auxiliares',
      image: '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_2.jpeg',
      images: [
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_1.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_2.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_3.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_4.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_5.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_6.jpeg',
        '/images/fotos/45MWTurbineGenerator/45MWTurbineGenerator_7.jpeg',

      ],
      description: 'Instalacion de tuberias de sistema de vapor y sistemas auxiliares',
      date: 'Enero 2026 - En proceso',
      location: 'Jamalco',
      jamaica: true,
    },
                { 
      id: 11, 
      title: 'Reparación tanques verticales', 
      info: 'Mechanical Cleaning of Precipitators',
      image: '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_4.JPG',
      images: [
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_1.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_2.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_3.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_4.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_5.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_6.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_7.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_8.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_9.JPG',
        '/images/fotos/reparacionTanquesVerticales/reparacionTanquesVerticales_10.JPG',
      ],
      description: 'Reparación mecanica y estructural a 6 Tanques precipitadores de 8x30 mts',
      date: 'Mayo 2026 - En proceso',
      location: 'Jamalco',
      jamaica: true,
    },
  ];

  const openModal = (project) => {
    setModalProject(project);
    setIsModalOpen(true);
    setIsModalReady(false);
    document.body.style.overflow = 'hidden';
    
    // Asegurar que el modal esté listo antes de inicializar el carousel
    setTimeout(() => {
      setIsModalReady(true);
      setCarouselKey(prev => prev + 1);
    }, 100);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalReady(false);
    document.body.style.overflow = '';
  };

  return (
    <div className="proyectos-container">
      <div className="halo" ref={haloRef}></div>
      
      {/* Hero Section */}
      <section className="proyectos-hero">
        <div className="container">
          <h1 className="hero-title">
            Nuestros <span className="highlight">Proyectos</span>
          </h1>
          <div className="animated-underline"></div>
          <p className="hero-subtitle">
            Hemos desarrollado proyectos exitosos en el sector energético y minería, cumpliendo en tiempo y forma con los alcances contratados. Cada proyecto refleja nuestro compromiso con la <span className="highlight">excelencia y la innovación.</span>
          </p>
        </div>
      </section>

            <div className="section-divider"></div>

            <section className="proyectos-hero">
        <div className="container">
          <h1 className="hero-title">
             <span className="highlight">Rêver ejecuta proyectos industriales
donde la confiabilidad, la velocidad y el
control técnico son críticos.</span>
          </h1>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Projects Section */}
      <section className="projects-section">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              <span className="highlight">Historial de Proyectos</span>
            </h2>
            <div className="animated-underline"></div>
            <p className="section-subtitle">
              Descubre algunos de nuestros proyectos más representativos que demuestran nuestra capacidad técnica y compromiso con la calidad.
            </p>
          </div>
          
          <div className="projects-grid">
            {projects.map((project, index) => (
              <div 
                key={project.id}
                className="project-card"
                data-project-id={project.id}
                onClick={() => openModal(project)}
                style={{animationDelay: `${index * 0.1}s`}}
              >
                <div className="card-front">
                  <div className="image-container">
                    <img src={project.image} alt={project.title} className="project-image" />
                    <div className="image-overlay"></div>
                  </div>
                  <div className="project-info">
                    <div className="project-content">
                      <h3 className="project-title">{project.title}</h3>
                      <p className="project-subtitle">{project.info}</p>
                      <p className="project-date">{project.date}</p>
                      <div className="badges-container">
                        {project.jamaica && <span className="project-badge">Jamaica</span>}
                        {project.mexico && <span className="project-badge">México</span>}
                        {project.internacional && <span className="project-badge">Internacional</span>}
                      </div>
                    </div>
                    <div className="badges-container">
                      Ver detalles
                      <svg className="flip-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/>
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <Link to="/contacto" className="contact-btn">
            Contáctanos
            <svg className="arrow-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4z"/>
            </svg>
          </Link>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && (
        <>
          <div className="modal-backdrop" onClick={closeModal}></div>
          <div className="modal-overlay">
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button onClick={closeModal} className="modal-close-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="rgb(248, 207, 71)" d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/>
                </svg>
              </button>
              
              <div className="modal-header">
                <h3 className="modal-title">{modalProject.title}</h3>
                <div className="animated-underline modal-underline"></div>
              </div>
              
              {/* Carrusel */}
              <section className="project-carousel">
                {isModalReady && (
                  <Splide 
                    key={carouselKey}
                    options={carouselOptions} 
                    className="carousel"
                  >
                    {modalProject.images && modalProject.images.map((image, index) => (
                      <SplideSlide key={index}>
                        <div className="carousel-image-container">
                          <img src={image} alt="Imagen del proyecto" />
                        </div>
                      </SplideSlide>
                    ))}
                  </Splide>
                )}
                {!isModalReady && (
                  <div className="carousel-loading">
                    <div className="carousel-image-container">
                      <img src={modalProject.images?.[0]} alt="Imagen del proyecto" />
                    </div>
                  </div>
                )}
              </section>
              
              <div className="project-details">
                <div className="detail-item">
                  <div className="detail-label"><strong>Descripción</strong></div>
                  <div className="detail-value">{modalProject.description}</div>
                </div>
                <div className="detail-meta">
                  <div className="meta-item">
                    <div className="meta-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                        <path fill="rgb(248, 207, 71)" d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zm0-12H5V6h14v2zm-7 5h5v5h-5v-5z"/>
                      </svg>
                    </div>
                    <span>{modalProject.date}</span>
                  </div>
                  <div className="meta-item">
                    <div className="meta-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16">
                        <path fill="rgb(248, 207, 71)" d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                      </svg>
                    </div>
                    <span>{modalProject.location}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Proyectos;